import { BaseMutationOptions } from '@apollo/client';

export type RefetchConfig = Pick<BaseMutationOptions, 'awaitRefetchQueries' | 'refetchQueries'>;

export const defaultRefetchConfig: RefetchConfig = {
  refetchQueries: ['GetComments'],
  awaitRefetchQueries: true,
};
